import api from '@/services/api';

const state = {
  rolePermissions: null,
};

const mutations = {
  SET_ROLE_PERMISSIONS(state, permissions) {
    state.rolePermissions = permissions;
  },
};

const actions = {
  async fetchPermissions({ commit, state }) {
    if (state.rolePermissions) {
      return; // Avoid refetching if already loaded
    }
    try {
        const configs = await api.data.list('configurations');
        const data = configs && configs.length > 0 ? configs[0] : null;
        
        commit('SET_ROLE_PERMISSIONS', data ? data.role_permissions : {});
    } catch (error) {
        console.error('Error fetching permissions:', error);
        commit('SET_ROLE_PERMISSIONS', {}); // Set empty to prevent reload loops
    }
  },
};

const getters = {
  rolePermissions: (state) => state.rolePermissions,
  hasPermissionsLoaded: (state) => state.rolePermissions !== null,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
